import { IFileExportConfig } from '../entities';

export interface IState {
  isError: boolean;
  errorMessage: string;
  pageNumber: number;
  data: IFileExportConfig[];
  loadingData: boolean;
}

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'FINISH_LOADING'
  | 'SET_ERROR'
  | 'START_LOADING'
  | 'UPDATE_DATA'
  | 'UPDATE_PAGE_NUMBER';

export interface IAction {
  type: ActionTypes;
  payload?: { [key: string]: any };
}

export function fileExportTableReducer(state: IState, action: IAction): IState {
  let newState: IState = null;
  const { type, payload } = action;

  switch (type) {
    case 'START_LOADING':
      newState = {
        ...state,
        loadingData: true,
      };
      break;
    case 'FINISH_LOADING':
      newState = {
        ...state,
        loadingData: false,
      };
      break;
    case 'UPDATE_DATA':
      newState = {
        ...state,
        data: payload.data,
      };
      break;
    case 'UPDATE_PAGE_NUMBER':
      newState = {
        ...state,
        pageNumber: payload.pageNumber,
      };
      break;
    case 'SET_ERROR':
      newState = {
        ...state,
        isError: true,
        errorMessage: payload.errorMessage,
      };
      break;
    case 'CLEAR_ERROR':
      newState = {
        ...state,
        isError: false,
        errorMessage: '',
      };
      break;
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }

  return newState;
}
